import React from "react";
import PropTypes from "prop-types";
import { BATCH_SCROLL, BATCH_SCROLL_UPDATE } from "./events";
import { getEventTarget } from "./BodyScroller";
import CustomEvent from "custom-event";

export default class Action extends React.Component {
  static propTypes = {
    action: PropTypes.func.isRequired
  };

  static defaultProps = {
    endBuffer: 300
  };

  rootRef = React.createRef();
  lastDetail = null;

  componentDidMount() {
    getEventTarget().addEventListener(BATCH_SCROLL, this.scrollEvent);
    // Request current size information
    this.rootRef.current.dispatchEvent(
      new CustomEvent(BATCH_SCROLL_UPDATE, { bubbles: true })
    );
  }

  componentWillUnmount() {
    getEventTarget().removeEventListener(BATCH_SCROLL, this.scrollEvent);
  }

  scrollEvent = e => {
    const { scrollLocation, visibleSize, contentSize } = e.detail;

    // Don't run action during initial size setting
    if (!this.lastDetail) {
      this.lastDetail = e.detail;
      return;
    }

    const locationChanged = scrollLocation !== this.lastDetail.scrollLocation;
    const contentChanged =
      visibleSize !== this.lastDetail.visibleSize ||
      contentSize !== this.lastDetail.contentSize;
    const canScroll = contentSize > visibleSize;
    const nearEnd =
      visibleSize + scrollLocation + this.props.endBuffer >= contentSize;
    const scrollingForward =
      e.detail.scrollLocation > this.lastDetail.scrollLocation;

    this.lastDetail = e.detail;
    if (
      (locationChanged && nearEnd && scrollingForward) ||
      (contentChanged && (nearEnd || !canScroll))
    ) {
      this.props.action();
    }
  };

  render() {
    // Events require dom context
    return <div ref={this.rootRef} />;
  }
}
